import { sanitizeText } from '../../../lib/sanitizeText'

export const actionTypes = {
  SET_PROMPT: 'SET_PROMPT',
  SET_STORAGE: 'SET_STORAGE'
} as const

export function setPrompt(prompt: string) {
  return { type: actionTypes.SET_PROMPT, prompt: sanitizeText(prompt) }
}

export function setStorage(storage: string | undefined) {
  return { type: actionTypes.SET_STORAGE, storage: storage && sanitizeText(storage) }
}

export type Action = ReturnType<typeof setPrompt | typeof setStorage>
